'use strict';

import jQuery from 'jquery';
import validate from './../../vendor/jquery.validate';
import Core from './../Core/Core';
import mvaultPromptTemplate from './views/mvaultPrompt.hbs';
import networkFailureTemplate from './views/networkFailure.hbs';
import dtd from './doubleTheDonation.js';

// For Litle (boo)
window.jQuery = jQuery;

/**
 * Common methods for both the donation engine and the custom donation forms
 */
var Donation = (function ($) {

  // Need to return a function for exporting.
  return function () {

    // Public methods and variables to in here.
    var my = {};

    // Public methods

    // Define shared constants
    my.PLEDGE_MIN = 5;
    my.PLEDGE_MIN_MSG = '<div>Your pledge total must be at least $' + my.PLEDGE_MIN + '.</div>';
    my.CREDIT_CARD_TYPES = [
      { id: 'visa', name: 'Visa', regex: /^4[0-9]{12}(?:[0-9]{3})?$/ },
      { id: 'mc', name: 'Mastercard', regex: /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/ },
      { id: 'amex', name: 'American Express', regex: /^3[47][0-9]{13}$/ },
      { id: 'discover', name: 'Discover', regex: /^6(?:011|5[0-9]{2})[0-9]{12}$/ }
    ];
    my.STUDIO_SOCIETY_ONETIME_MIN = 1200;
    my.STUDIO_SOCIETY_SUSTAINING_MIN = 100;
    my.PRESIDENT_SOCIETY_ONETIME_MIN = 10000;
    my.PRESIDENT_SOCIETY_SUSTAINING_MIN = 1000;
    my.SUBMISSION_DELAY = 2000;
    my.INVALID_MVAULT_RESPONSE = 'MVault failed to return a proper response';
    my.INVALID_TRANSACTION_RESPONSE = 'Invalid response from server';

    // Define a skeleton submission object that the backend is expecting
    var SUBMISSION = {
      custom_form_id: '',
      agree_to_terms: '',
      pledge_code_override: '',
      pledge_code_pattern: '',
      solicitor: '',
      transaction_type: '',
      is_one_time: '',
      shipping: '',
      gift_amount: '',
      input_decoded: '',
      gift_id: [],
      gift_quantity: [],
      monthly_amount: '',
      monthly_no_gift_program: '',
      one_time_popular_amounts: '',
      one_time_other_amount: '',
      one_time_no_gift_program: '',
      additional_pledge_amount: '',
      additional_pledge_monthly_amount: '',
      no_gift_additional_pledge_amount: '',
      fname: '',
      lname: '',
      alt_fname: '',
      alt_lname: '',
      address_line1: '',
      address_line2: '',
      address_zip: '',
      address_country: '',
      address_city: '',
      address_state: '',
      email: '',
      phone_number: '',
      shipping_same: '',
      shipping_fname: '',
      shipping_lname: '',
      shipping_address_line1: '',
      shipping_address_line2: '',
      shipping_address_zip: '',
      shipping_address_country: '',
      shipping_address_city: '',
      shipping_address_state: '',
      payment_type: '',
      cc_last_four: '',
      cc_type: '',
      cc_expiration_month: '',
      cc_expiration_year: '',
      cc_cvv: '',
      vantiv_token: '',
      is_cc: '',
      is_eft: '',
      checking_routing_number: '',
      checking_account_number: '',
      member_id: '',
      special_instructions: '',
      custom_return_url: '',
      paypage_registration_id: '',
      payment_id: '',
      company_id: null,
      dtd_status: dtd.dtdStatus
    };

    // Cache the important elements on the page
    var $ajaxLoader = $('#ajax-loader-overlay'),
      $donationForm = $('#donation-form');

    /**
     * Does common init
     */
    my.init = function () {

      // Make sure we have eProtect
      if (typeof LitlePayPage !== 'function') {
        my.handleUI('<div>We are having technical difficulties.  Please try again later.</div>');
      }

      // Set up validation.
      $.validator.addMethod('zipcode', function (value, element) {
        return this.optional(element) || /^\d{5}(?:-\d{4})?$/.test(value);
      }, 'Please provide a valid zipcode.');

      $.validator.addMethod('routing-number-valid', function (value, element) {
        return (3 * (parseInt(value.substr(0, 1), 10) + parseInt(value.substr(3, 1), 10) + parseInt(value.substr(6, 1), 10)) +
          7 * (parseInt(value.substr(1, 1), 10) + parseInt(value.substr(4, 1), 10) + parseInt(value.substr(7, 1), 10)) +
          parseInt(value.substr(2, 1), 10) + parseInt(value.substr(5, 1), 10) + parseInt(value.substr(8, 1), 10)) % 10 === 0;
      }, 'Please enter a valid routing number.');

      $.validator.addMethod('tpt-email', function (value, element) {
        var userDomainSplit = value.split('@'),
          userPart = userDomainSplit[0],
          domainPart = userDomainSplit[1],
          userRegex = new RegExp(
            "(^[-!#$%&'*+/=?^_`{}|~0-9A-Z]+(\\.[-!#$%&'*+/=?^_`{}|~0-9A-Z]+)*$"
            + '|^"([\\001-\\010\\013\\014\\016-\\037!#-\\[\\]-\\177]|\\\\[\\001-\\011\\013\\014\\016-\\177])*"$)'
            , 'i')
          , domainRegex = new RegExp(
            '^(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\\.)+(?:[A-Z]{2,6}|[A-Z0-9-]{2,})$'
            + '|^\\[(25[0-5]|2[0-4]\\d|[0-1]?\\d?\\d)(\\.(25[0-5]|2[0-4]\\d|[0-1]?\\d?\\d)){3}\\]$'
            , 'i');

        return userRegex.test(userPart) && domainRegex.test(domainPart);
      }, 'Please provide a valid email.');

      // TODO: Rewrite the expiration validation. Plugin does not seem to gracefully handle the case of two inputs whose values control a single error

      // Setup a validation rule that validates the entire expiration date.
      // This is called when a request for the validation of the expiration year
      // is triggered
      $.validator.addMethod('expiration-date-valid', function (value, element) {

        // Grab the month and year from the inputs from the form
        var $expMonth = $('#payment-charge-card-expiration-month'),
          $expYear = $('#expiration-year');

        if ($expYear[0].selectedIndex === 0) {
          var date = new Date();

          // Month is indexed from 0 in JS.  Also, we can't just parseInt here, because IE
          // thinks it's octal with a leading zero.  However, we need the 0 in the string for
          // validation.
          var expMonthVal = $expMonth.val();
          var expMonthInt = expMonthVal.substr(0, 1) === '0' ? parseInt(expMonthVal.substr(1), 10) : parseInt(expMonthVal, 10);

          if (expMonthInt <= date.getMonth()) {
            $expMonth.addClass('error');
            $expYear.addClass('error');

            return false;
          }
        }

        // We cleared validation on the year.  Clear it on the month as well, even if it
        // is invalid.  It will be validated again on submit.
        $expMonth.removeClass('error');
        $expYear.removeClass('error');

        return true;
      }, 'Please enter a valid expiration date.');

      my.validator = $('#donation-form').validate({
        errorPlacement: function (error, element) {

          // If there is a label already, like in a checkbox, place it after that.
          var $potentialLbl = $(element).next('label');

          if ($potentialLbl.length > 0) {
            error.insertAfter($potentialLbl);
          } else {
            error.insertAfter(element);
          }
        },
        onsubmit: false,
        onfocusout: function (element, e) {
          if ($(element).parents('#payment-information').eq(0).attr('id') !== 'payment-information') {
            this.element(element);
            my.validateAllAreas();
          }
        },
        invalidHandler: function (event, validator) {
          var errors = validator.numberOfInvalids();

          if (errors) {
            var errorEl = validator.errorList[0].element;
            errorEl.focus();
            $(window).scrollTop($(errorEl).offset().top - $('#body-wrapper div:first-child').offset().top);
          }
        }
      });

      // Couldn't use a custom validator because synchronous AJAX calls no longer work (for good reason)
      // in jQuery.  Also, JSONP wouldn't work to directly query the service because it needs to return
      // false on failed validation and true on success, not the data from the service.  So, I made a proxy
      // request from our server that returns the data in the correct format.
      if ($('#payment-eft-routing-number').length > 0) {
        $('#payment-eft-routing-number').rules('add', {
          remote: {
            url: "/donation/isRoutingNumberValid"
          }
        });

        // Also get the bank name on change.
        // TODO: Removing bank name lookup. Service that was used for this no longer works.
      }

      // Set up the zip code auto fill of city and state.
      $('#address-zip, #shipping-address-zip').blur(function () {
        var $this = $(this);
        var zipVal = $this.val();

        // Go out to ziptastic and check for it.
        if (zipVal !== '') {
          $.ajax({
            url: '//ziptasticapi.com/' + zipVal,
            dataType: 'json'
          }).then(function (data) {
            var prefix = 'shipping-';

            if ($this.attr('id').indexOf('shipping') === -1) {
              prefix = '';
            }

            $('#' + prefix + 'address-state').val(data.state);

            if (data.city) {
              $('#' + prefix + 'address-city').val(
                data.city.replace(/\w\S*/g, function (txt) {
                  return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                })
              );
            }
          }).catch(function () {
            // Drop any errors that stem from trying to lookup the city
          });
        }
      });

      // Need to get that focus out/click for the terms
      $('.agree-to-terms').each(function (i, el) {
        $(el).on('blur click', function () {

          // We need to make sure all get the value before validation.
          if ($(this).prop('checked')) {
            $('.agree-to-terms').prop('checked', true);
          } else {
            $('.agree-to-terms').prop('checked', false);
          }

          $('#donation-form').validate().element(this);
          my.validateArea('#pledge');
        });
      });

      // Need to get that focus out/click for the terms
      $('.agree-to-eft-terms').each(function (i, el) {
        $(el).on('blur click', function () {

          // We need to make sure all get the value before validation.
          if ($(this).prop('checked')) {
            $('.agree-to-eft-terms').prop('checked', true);
          } else {
            $('.agree-to-eft-terms').prop('checked', false);
          }

          $('#donation-form').validate().element(this);
          my.validateArea('#pledge');
        });
      });

      // Set up dialog for terms.
      $('.terms-of-agreement-link').each(function (i, el) {
        $(el).click(function (e) {
          $('#terms-of-agreement').dialog({
            title: 'Sustainer Terms of Agreement',
            width: 500,
            modal: true,
            draggable: false,
            closeText: '',
            classes: {
              'ui-dialog': 'terms-of-agreement-dialog'
            }
          }).unbind().click(function (e) {
            var $potentialLink = $(e.target);

            if ($potentialLink.attr('id') === 'agree-to-terms-btn') {
              $('.agree-to-terms').prop('checked', true);
              $('#donation-form').validate().element($('.agree-to-terms'));
              my.validateArea('#pledge');
            }

            $('#terms-of-agreement').dialog('close').dialog('destroy');

            e.preventDefault();
          });

          e.preventDefault();
        });
      });

      // Set up dialog for EFT terms.
      $('.terms-of-eft-agreement-link').each(function (i, el) {
        $(el).click(function (e) {
          if (my.isOneTimeFunc()) {
            $('#terms-of-eft-agreement').find('.sustaining-message').hide();
            $('#terms-of-eft-agreement').find('.one-time-message').show();
          } else {
            $('#terms-of-eft-agreement').find('.sustaining-message').show();
            $('#terms-of-eft-agreement').find('.one-time-message').hide();
          }

          $('#terms-of-eft-agreement').dialog({
            title: 'EFT Terms of Agreement.',
            width: 500,
            modal: true,
            draggable: false,
            closeText: '',
            classes: {
              'ui-dialog': 'terms-of-agreement-dialog'
            }
          }).unbind().click(function (e) {
            var $potentialLink = $(e.target);

            if ($potentialLink.attr('id') === 'agree-to-eft-terms-btn') {
              $('#agree-to-eft-terms').prop('checked', true);
              $('#donation-form').validate().element($('#agree-to-eft-terms'));
              my.validateArea('#pledge');
            }

            $('#terms-of-eft-agreement').dialog('close').dialog('destroy');

            e.preventDefault();
          });

          e.preventDefault();
        });
      });
    };

    my.decode = function decode(items) {
      for (var i = 0; i < items.length; i++) {
        var nodeToDecode = $(items[i].selector),
          valToDecode = nodeToDecode.val();

        if (typeof valToDecode !== 'undefined' && valToDecode.length > 0 && items[i].key) {
          nodeToDecode.val(my.keyRotate(valToDecode, items[i].key, true));
        }
      }
    };

    /**
     * Key based text-rotation
     *
     * @param {string} text The text to rotate
     * @param {string} key The key used to do the rotation
     * @param {boolean} reverse The direction to rotate
     *
     * @return string The rotated text
     */
    my.keyRotate = function keyRotate(text, key, reverse) {

      // Surrogate pair limit
      var bound = 0x10000;

      // Create string from character codes
      return String.fromCharCode.apply(null,

        // Turn string to character codes
        text.split('').map(function (v, i) {

          // Get rotation from key
          var rotation = key[i % key.length].charCodeAt(0);

          // Are we decrypting?
          if (reverse) {
            rotation = -rotation;
          }

          // Return current character code + rotation
          return (v.charCodeAt(0) + rotation + bound) % bound;
        })
      );
    };

    my.getCreditCardTypes = function getCreditCardTypes(cardNumber) {

      return my.CREDIT_CARD_TYPES.filter(function (type) {
        return cardNumber.match(type.regex);
      });
    };

    my.qualifiesForStudioSociety = function qualifiesForStudioSociety(isOneTime, amount) {

      return (isOneTime === true && amount >= my.STUDIO_SOCIETY_ONETIME_MIN) ||
        (isOneTime === false && amount >= my.STUDIO_SOCIETY_SUSTAINING_MIN);
    };

    my.qualifiesForPresidentSociety = function qualifiesForPresidentSociety(isOneTime, amount) {

      return (isOneTime === true && amount >= my.PRESIDENT_SOCIETY_ONETIME_MIN) ||
        (isOneTime === false && amount >= my.PRESIDENT_SOCIETY_SUSTAINING_MIN);
    };

    my.saveState = function saveState(state) {

      return $.ajax({
        type: 'POST',
        url: '/donation/saveState/',
        data: state
      });
    };

    my.getState = function getState(id) {
      return $.ajax({
        type: 'GET',
        url: '/donation/getState/?uuid=' + id
      });
    };

    my.getOnetimeShippingTotal = function getOnetimeShippingTotal(giftTotal, shippingTotal) {

      // Create a container for the computed shipping
      var computedShipping = 0.0;

      // Shipping of exactly zero means a minimum shipping isn't necessary.
      if (shippingTotal !== 0.0) {

        var potentialShipping = 3.0;

        if (giftTotal > 200.0) {
          potentialShipping = 9.0;
        } else if (giftTotal > 100.0) {
          potentialShipping = 6.0;
        }

        computedShipping = Math.max(shippingTotal, potentialShipping);
      }

      return computedShipping;
    };

    /**
     * Validates an area of the form to display the error message for it
     *
     * @param {string} area
     */
    my.validateArea = function (area) {

      // Only show validation error when fields have errors and are shown.
      var showError = false;

      $.each($(area + '-information').find('.error'), function (i, el) {
        if ($(el).is(':visible')) {
          showError = true;

          return false;
        }
      });

      if (showError) {
        $(area + '-errors').fadeIn();
      } else {
        $(area + '-errors').fadeOut();
      }
    };

    my.clearValidationErrors = function () {
      my.validator.resetForm();
      my.validator.reset();
    };

    /**
     * Calls "validateArea" for all areas
     */
    my.validateAllAreas = function () {
      var areas = ['#pledge', '#billing', '#payment', '#shipping'];

      for (var i in areas) {
        if (areas.hasOwnProperty(i)) {
          my.validateArea(areas[i]);
        }
      }
    };

    /**
     * Used when clicking on the more link for a premium
     *
     * @param e
     */
    my.moreLinkClick = function (e) {

      e.preventDefault();

      // Get access to the parent gift and the full description elements
      var $this = $(this),
        $gift = $this.parents('.gift'),
        $fullDescription = $gift.find('.search-description');

      // Toggle the hide class on the toggle messaging elements as well as the
      // full item description
      $this.find('.show-msg, .hide-msg').toggleClass('hide');
      $fullDescription.fadeToggle();
    };

    /**
     Form Data -> handleSubmission -> promise
       -> stop at Passport if it needs to display message
         -> caller determine what happens with dialog
           -> DE listens for clicks on "continue/ignore"
            -> sends data to process directly
       -> or continue to process
         -> process gives back transaction status
           -> status is either true or false with or w/o message
             -> if false display message and return status
             -> if true return status
     **/

    /**
     * Given a partial transaction submission, attempts a full process
     * including a Passport message check followed by a transaction process if
     * the Passport message does not need to be displayed. Creates a promise
     * that resolves to either a transaction status bundle or a DOM element
     * representing the Passport message. The promise may also reject with a
     * failure message from either the Passport or processing promise.
     *
     * @param {object} data Partial submission data for a transaction
     * @returns {Promise.<T>} A promise that either resolves successfully with
     *                        either a transaction status bundle or a DOM
     *                        element representing the Passport message. The
     *                        promise may also reject with a failure message
     *                        from either the Passport or transaction process.
     *                        The transaction status bundle may represent a
     *                        successful or unsuccessful transaction based on
     *                        its contents
     */
    my.handleSubmission = function handleSubmission(data) {

      // Create the Passport message promise check that will synchronously call
      // the process transaction method once it is finished
      return my.checkForPassport(data).then(
        function handleMVaultSuccess(status) {

          // If the Passport check returned anything but false, then stop doing
          // work and return the value to the chain
          if (status !== false) {
            return status;
          }

          // If the Passport message does not need to be shown, then create
          // and return a transaction processing promise
          return my.processTransaction(data).
            then(
              function (transactionResult) { return transactionResult; },
              function (failure) { return failure; }
            );
        },
        function (failure) { return failure; }
      );
    };

    /**
     * Given a partial transaction submission, attempts to check see if the
     * transaction should be prompted with Passport messaging. Creates a promise
     * for the check that either resolves with either a DOM element representing
     * the on screen Passport dialog or false if the message is not displayed.
     * The promise may also reject with a server error or a general MVault error
     * if it responds with an unknown error code. Creates a delay promise that
     * controls displaying the loading graphic for a minimum amount of time so
     * that it does not disappear too quickly.
     *
     * @param {object} data Partial submission data for a transaction
     * @returns {Promise.<T>} A promise that resolves with either a DOM element
     *                        representing the on screen Passport dialog or
     *                        false if the prompt is not displayed. The promise
     *                        may also reject with either a server or unknown
     *                        status code error
     */
    my.checkForPassport = function checkForPassport(data) {

      // Reject immediately if an empty submission is passed in
      if (typeof data === 'undefined') {
        let d = $.Deferred();
        d.reject('Submitted data is invalid');

        return d.promise();
      }

      // Show the loading graphic while doing work
      $ajaxLoader.show();

      // Build a full submission object from the passed in partial object
      var submission = my.createSubmission(data);

      // Create a promise representing the Passport messaging check. This is
      // done outside of the delay promise so that the processing can happen in
      // parallel to the minimum submission delay
      var passportPromise = my.passportPromise(submission);

      // Return a promise that will resolve or reject after both the minimum
      // submission delay and the Passport message check promise have either
      // resolved or rejected
      return Core.utils.delay(my.SUBMISSION_DELAY).
        then(
          function () {

            // Once the minimum submission delay finishes, handle the result
            // of the Passport message check promise
            return passportPromise.then(
              function (showPassportMessage) {

                // If the Passport message check resolved to true, then display
                // the Passport message to the end user and return a reference
                // to the dialog element to the promise chain
                if (showPassportMessage === true) {
                  return my.handleUI(
                    mvaultPromptTemplate(), '75%', false
                  );
                } else {

                  // Otherwise simply pass the value down the chain
                  return showPassportMessage;
                }
              },
              handleNetworkFailure
            );
          }
        ).
        then(
          function (data) {
            $ajaxLoader.hide();
            return data;
          }
        ).
        catch(
          function (data) {
            $ajaxLoader.hide();
            return Core.utils.failure(data);
          }
        );
    };

    /**
     * Creates a passport check Promise and handles the response from the
     * server. Attempts to validate that the data is of the correct shape. If
     * the response is valid, the promise will resolve with either true or false
     * depending on if the check passed or failed. The promise will reject
     * with the a failure message or exception in the case of an invalid server
     * response or a server error.
     *
     * @param {Object} submission The submission data to test against
     * @returns {Promise.<T>|*} A promise that either resolves with a boolean
     *                          based on the server response or rejects with
     *                          either a failure string or exception
     */
    my.passportPromise = function passportPromise(submission) {

      // Request a new Passport check and then handle the response
      return my.createPassportCheck(submission).
        then(
          function (mvaultResult) {

            // Create a deferred to handle the response from the server. It
            // may still error if the server returned an unknown value
            var deferred = $.Deferred();

            // If the server returned '1', then the message should be displayed
            if (mvaultResult === '1') {

              // Tell whoever is listening to display the message
              deferred.resolve(true);
            } else if (mvaultResult === '0') {

              // If the server returned '0', then the message should not be
              // displayed. Tell whoever is listening to not display
              deferred.resolve(false);
            } else {

              // If anything else was returned by the server, then reject the
              // inner promise as we do not know what it means
              deferred.reject(my.INVALID_MVAULT_RESPONSE);
            }

            // Return the inner promise so it can be chained from
            return deferred.promise();
          },
          function (jqXHR, textStatus, error) { return Core.utils.failure(error); }
        );
    };

    /**
     * Makes a request to the server to check to see if the Passport upsell
     * prompt should be displayed based on the passed in submission data. Will
     * resolve with the response from the server or reject in the case of a
     * server error.
     *
     * @param {Object} submission The submission data to test against
     * @returns {Promise.<T>|*} A promise that will resolve with the server
     *                          response or reject from a server failure
     */
    my.createPassportCheck = function createPassportCheck(submission) {

      // Create a new Passport message check
      return $.ajax({
        method: 'POST',
        url: '/donation/checkForPassportMessage/',
        data: submission
      }).promise();
    };

    /**
     * Given a partial transaction submission, attempts to process a transaction
     * against the server. Creates a promise for the transaction that either
     * resolves with a transaction status bundle or rejects with either a
     * server error or JSON parse error. Failed transaction status bundles will
     * display their error message to the user, and rejected server errors /
     * JSON error will be passed off to the network failure handler. Creates a
     * delay promise that controls displaying the loading graphic for a minimum
     * amount of time so that it does not disappear too quickly.
     *
     * @param {object} data Partial submission data for a transaction
     * @returns {Promise.<T>} A promise that either resolves successfully with
     *                        a transaction status bundle or rejects with a
     *                        server or JSON error. The transaction status
     *                        bundle may represent a successful or unsuccessful
     *                        transaction based on its contents
     */
    my.processTransaction = function processTransaction(data) {

      // Show the loading graphic while doing work
      $ajaxLoader.show();

      var preTransaction;

      // Handle credit cards through eProtect
      if (data.payment_type === 'cc') {
        preTransaction = my.createEProtectRequest().then(function (response) {

          // Create a copy of the passed in data so it can be mutated with
          // the data from Vantiv
          var subData = $.extend({}, data);

          // Augment data with eProtect response
          subData.paypage_registration_id = response.paypageRegistrationId;
          subData.payment_id = response.orderId;
          subData.cc_last_four = response.lastFour;
          subData.cc_type = response.type;
          subData.cc_cvv = '000';

          return subData;
        });
      } else {
        // Everything else is simply a pass through
        preTransaction = $.Deferred();
        preTransaction.resolve(data);
      }

      // Return a promise that will resolve or reject after both the minimum
      // submission delay and the transaction processing promise have either
      // resolved or rejected
      return Core.utils.delay(my.SUBMISSION_DELAY).
        then(function () {
          return preTransaction;
        }).then(function (subData) {

          // Build a full submission object from the passed in partial object,
          // create a flag for PayPal that will affect the loading graphic logic,
          // and create a holder for the transaction processing promise
          var submission = my.createSubmission(subData);

          // Send the submission data to the server for process and wait for a
          // response. This is done outside of the delay promise so that the
          // processing can happen in parallel to the minimum submission delay
          return my.transactionPromise(submission);
        }).then(function (transactionResult) {

          // If the transaction promise resulted in a non-successful
          // transaction, prompt the user with a hopefully helpful
          // error message. (Incorrect zip code for instance)

          // Redirect the browser to the URL returned from the transaction
          if (transactionResult.result === 'pending') {
            window.location.href = transactionResult.url;
          } else if (transactionResult.result === 'bad_address') {

            // This failure may occur if the credit card billing address
            // does not match the address submitted by the user
            throw 'We’re sorry. ' +
            'The information about your credit card and mailing address did not match your bank’s records. ' +
            'Please double-check that all of your information is correct and submit again.' +
            '<br/> ' +
            'Thank You!';
          } else if (transactionResult.result === 'bad_bank_account') {
            // This failure may occur if the routing/account numbers are
            // rejected by the payment processor
            throw 'We’re sorry. ' +
            'The information for your bank account could not be verified. ' +
            'Please double-check that all of your information is correct and submit again.' +
            '<br/> ' +
            'Thank You!';
          } else if (transactionResult.result === 'bad_credit_card') {
            // This failure may occur if the credit card number was
            // invalid but passed formatting tests, or if the CVV is bad
            throw 'We’re sorry. ' +
            'The information for your credit card did not match your bank’s records. ' +
            'Please double-check that all of your information is correct and submit again.' +
            '<br/> ' +
            'Thank You!';
          } else if (transactionResult.result === 'invalid_email') {
            // This failure will occur when the email address fails PBS's validation rules
            throw 'Sorry, the email address you entered was invalid. ' +
            'Please verify your email address and try again. ' +
            '<br/>' +
            'Thank You!';
          } else if (transactionResult.result !== 'success') {
            // General failure
            throw 'Sorry, something didn’t quite work right. ' +
            'Please verify your address and payment information. ' +
            'If you continue to have problems, please call us at 1-888-229-1500 anytime to make your contribution.' +
            '<br/>' +
            'Thank You!';
          }

          // Return the full transaction result to anyone else listening
          return transactionResult;
        })
        .then(

          // Now that the transaction promise is completed, remove the loading
          // graphic form the UI
          function (data) {

            if (data.result !== 'pending') {
              $ajaxLoader.hide();
            }

            // Pass through the data with modification
            return data;
          })
        .catch(function (error) {

          // If a failure occurred, then try to restore the credit card and
          // CVV field that Vantiv injects with placeholder data
          if (data.cc_number) {
            document.getElementById('payment-charge-card-number').value = data.cc_number;
          }

          if (data.cc_cvv) {
            document.getElementById('payment-charge-card-cvv').value = data.cc_cvv;
          }

          $ajaxLoader.hide();

          // Display the message to the user
          my.handleUI('<div>' + error + '</div>');
        });
    };

    /**
     * Returns a promise that will resolve or reject based on the return from Vantiv.
     *
     * @return {Promise}
     */
    my.createEProtectRequest = function createEProtectRequest() {
      var promise = $.Deferred();

      // Talk to Vantiv for eProtect
      var litleRequest = {
        'paypageId': $('#request\\$paypageId').val(),
        'reportGroup': 'ecommerce',
        'orderId': $('#request\\$orderId').val(),
        'id': $('#request\\$orderId').val(),
        'url': Core.config.eProtect && Core.config.eProtect.url
      }, litleFormFields = {
        accountNum: document.getElementById('payment-charge-card-number'),
        cvv2: document.getElementById('payment-charge-card-cvv'),
        paypageRegistrationId: document.getElementById('response$paypageRegistrationId'),
        bin: document.getElementById('response$bin')
      };

      new window.LitlePayPage().sendToLitle(litleRequest, litleFormFields,
        function success(response) {
          promise.resolve(response);
        },
        function error(response) {
          var errors = {
            871: 'Invalid card number. Check and retry. (Not Mod10)',
            872: 'Invalid card number. Check and retry. (Too short)',
            873: 'Invalid card number. Check and retry. (Too long)',
            874: 'Invalid card number. Check and retry. (Not a number)',
            875: 'We are experiencing technical difficulties. Please try again later or call 555-555-1212',
            876: 'Invalid card number. Check and retry. (Failure from Server)',
            881: 'Invalid card validation code. Check and retry. (Not a number)',
            882: 'Invalid card validation code. Check and retry. (Too short)',
            883: 'Invalid card validation code. Check and retry. (Too long)'
          },
            error = response.message,
            errorNum = parseInt(response.response);

          if (errors[errorNum] !== undefined) {
            error = errors[errorNum];
          }

          promise.reject(error);
        },
        function timeout() {
          promise.reject('Transaction timed out.');
        }, 15000 /* Timeout delay */
      );

      return promise;
    };

    /**
     * Creates a transaction Promise and handles the response from the server.
     * Attempts to parse the response from the server as JSON and validate that
     * the parsed data is of the correct shape. If the response is valid, the
     * promise will resolve with the parsed response. The promise will reject
     * with the a failure message or exception in the case of an invalid server
     * response, a failed JSON parse, or server error.
     *
     * @param {Object} submission The submission data to create a transaction
     *                            with
     * @returns {Promise.<T>|*} A promise that either resolves with a valid
     *                          parsed server response or rejects with either a
     *                          failure string or exception
     */
    my.transactionPromise = function transactionPromise(submission) {

      // Request a new transaction and then handle the response
      return my.createTransaction(submission).
        catch(function (jqXHR, textStatus, error) {
          if (error instanceof SyntaxError) {
            throw new Error(my.INVALID_TRANSACTION_RESPONSE);
          }

          throw error;
        }).
        then(
          function (transactionResult) {

            // Make sure that the parsed result contains the expected fields.
            // Otherwise reject the transaction
            if (typeof transactionResult.result === 'string' &&
              typeof transactionResult.mvaultToken !== 'undefined' &&
              typeof transactionResult.url !== 'undefined') {
              return transactionResult;
            } else {

              // If any check failed then reject with an invalid response error
              throw new Error(my.INVALID_TRANSACTION_RESPONSE);
            }
          }
        );
    };

    /**
     * Makes a request to the server to process a transaction that is
     * represented by the submission data. Will resolve with the response from
     * the server or reject in the case of a server error.
     *
     * @param {Object} submission The submission data to process
     * @returns {Promise.<T>|*} A promise that will resolve with the server
     *                          response or reject from a server failure
     */
    my.createTransaction = function createTransaction(submission) {

      // Create a new transaction
      return $.ajax({
        method: 'POST',
        url: '/donation/process/',
        data: submission,
        dataType: 'json'
      }).promise();
    };

    /**
     * Takes a potentially partial object of submission data and extends the
     * default submission skeleton with its data. Returns the resulting object.
     *
     * @param {object} data The partial submission data to extend the skeleton
     *                      data with
     *
     * @returns {object} The result of extending the skeleton with the partial
     *                   submission data
     */
    my.createSubmission = function createSubmission(data) {

      // Add in the company ID.
      data.company_id = dtd.companyId;
      data.dtd_status = dtd.dtdStatus;

      // Extend the submission skeleton with the passed in data and then filter
      // out any extraneous keys added by the incoming data
      return Core.utils.filterObjectKeys(
        $.extend(true, {}, SUBMISSION, data),
        SUBMISSION
      );
    };

    /**
     * A helper function that proxies a list of arguments over to the code that
     * actually renders and updates the UI. Returns the rendered UI element
     *
     * @returns {jQuery} A rendered jQuery dialog UI element
     */
    my.handleUI = function handleUI() {
      return Core.utils.dialog.apply(window, arguments);
    };

    /**
     * Get the values for the form for a signed in user from member portal.
     */
    my.getMemberInfo = function getMemberInfo() {
      var uuid = my.getUUID();

      if (uuid) {
        return $.ajax('/api/v1/account/' + uuid + '/info', {}).done(function (data) {

          // FIXME: This logic should not be generalized. Split the implementation for donation engine vs custom forms

          if (data.account) {
            $('#fname').val(data.account.first_name);
            $('#lname').val(data.account.last_name);
            $('#address-line1').val(data.account.address_line1);
            $('#address-line2').val(data.account.address_line2);
            $('#address-city').val(data.account.city);
            $('#address-state').val(data.account.state);
            $('#address-zip').val(data.account.zip);
            $('#member-id').val(data.account.member_number);

            if (data.account.country) {
              $('#address-country').val(data.account.country);
            }

            // Custom forms use email, donation engine uses email-address.
            $('#email, #email-address').val(data.email);

            // If the user has an available email to us, then disable the
            // email field
            if (data.email) {
              let $email = $('#email, #email-address').eq(0);

              if ($email) {
                let $hiddenEmail = $email.clone();
                $hiddenEmail.prop('type', 'hidden');
                $hiddenEmail.prop('readonly', true);
                $email.prop('disabled', true);
                $email.after($hiddenEmail);
              }
            }

            $('#phone-number').val(data.account.phone && data.account.phone.replace(/[^0-9]/g, '') || '');
          }

          return data;
        }).fail(function () {
          Core.utils.dialog('<div>Unable to get member information.</div>');
        });
      }
    };

    /**
     * Gets the UUID from the cookie
     *
     * @return {string}
     */
    my.getUUID = function getUUID() {
      var passportCookie = getCookie('passport_access');

      if (passportCookie) {
        var decoded = decodeURIComponent(decodeURIComponent(passportCookie));

        try {
          decoded = JSON.parse(decoded);

          return decoded.uuid;
        } catch (e) {
          Core.utils.dialog('<div>Could not load your login information.</div>');
        }
      }

      return '';
    };

    // Private methods

    /**
     * @param {string} cname
     * @returns {string}
     */
    function getCookie(cname) {
      var name = cname + "=",
        decodedCookie = decodeURIComponent(document.cookie),
        ca = decodedCookie.split(';');

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }

      return "";
    }

    /**
     * Promise failure handler that handles network errors. Displays the error
     * in a dialog box and returns a rejected promise with the dialog DOM
     * element as a value.
     *
     * @param {*} message An error message to display
     * @returns {Promise.<T>} A rejected promise with the dialog element as
     *                        the value
     */
    function handleNetworkFailure(message) {

      // Display the message to the user
      my.handleUI(networkFailureTemplate(
        { message: message }
      ));

      // Return a rejected promise with the error message
      return Core.utils.failure(message);
    }

    return my;
  };
})(jQuery);

export default new Donation()
